var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSilence = function SvgSilence(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0L0 50l50 50 50-50zm0 2.777l47.225 47.225L50 97.225 2.775 50.002zm0 2.677L5.454 50.002 50 94.548l44.546-44.546L50 5.454zm0 6.945l37.601 37.603L50 87.603 12.399 50.002 50 12.399zm-6.135 26.974v21.254L62.272 50z",
    fill: "#f0cf75",
    fillOpacity: 1,
    strokeWidth: 0.036
  })));
};

export default SvgSilence;